<template>

  <div class="row">
    <div class="col-sm-12">

      <div class="row mt-4">
        <div class="col-md-12">
          <strong>
            {{infoTotalModels}}
          </strong>
        </div>
      </div>

      <table>
        <thead>
        <tr>
          <th>ID</th>
          <th>Criado em</th>
          <th>Atualizado em</th>
          <th>Tipo</th>
          <th>Categoria</th>
          <th>Nome</th>
          <th>Apelido</th>
          <th>status</th>
          <th>Descrição</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="app in apps" :key="app.id">
          <td>{{ app.id }}</td>
          <td>{{ app.createdAt | datetime }}</td>
          <td>{{ app.updatedAt | datetime }}</td>
          <td>{{ app.appType }}</td>
          <td>{{ app.category }}</td>
          <td>{{ app.name }}</td>
          <td>{{ app.nickname}}</td>
          <td>{{ app.status }}</td>
          <td>{{ app.description }}</td>
          <td><router-link :to="`/admin/apps/${app.id}/edit`" @click="showDetail(app)" class="btn btn-outline">Editar</router-link></td>
        </tr>
        </tbody>
      </table>

      <div class="row">
        <div class="col-md-12 my-1">
          <Pagination
            v-model="meta.currentPage"
            :total-count="meta.totalCount"
            :total-pages="meta.totalPages"
            @pagination="pagination"
          />
        </div>
      </div>

    </div>

    <Modal v-if="currentApp" v-model="showModal">
      <div slot="header">
        <h3><strong>{{ currentApp.name }}</strong></h3>
      </div>

      <div class="row">
        <div class="col-md-12 mt-3">
          <label for="app-type">Tipo</label>
          <input v-model="currentApp.appType" type="text" class="form-control" id="app-type">
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 mt-3">
          <label for="app-category">Categoria</label>
          <input v-model="currentApp.category" type="text" class="form-control" id="app-category">
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 mt-3">
          <label for="app-short-name">Nome (shortName)</label>
          <input v-model="currentApp.shortName" type="text" class="form-control" id="app-short-name">
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 mt-3">
          <label for="app-status">Status</label>
          <input v-model="currentApp.status" type="text" class="form-control" id="app-status">
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 mt-3">
          <label for="app-description">Descrição</label>
          <input v-model="currentApp.description" type="text" class="form-control" id="app-description">
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-default" @click="showModal=false">Cancelar</button>
        <button class="btn btn-primary" @click="saveApp()">Salvar</button>
      </div>
    </Modal>

  </div>

</template>

<script>
  import Modal from '@/components/shares/specialTag/Modal'
  import ModelMapper from '@/mixins/ModelMapper'
  import Pagination from '@/components/shares/specialTag/Pagination'

  export default {
    components: { Modal, Pagination },
    computed: {
      apps() {
        return this.getModels || []
      }
    },
    created() {
      this.defaultModelSetting.updateQueryURL = true
      this.order.createdAt = 'desc'
      this.asyncTemplateSelect({
        byURL: true,
        pagination: true
      })
    },
    data() {
      return {
        currentApp: null,
        modelPathPrefix: 'admin',
        nameModel: 'App',
        showModal: false
      }
    },
    methods: {
      find() {
        this.asyncTemplateSelect()
      },
      saveApp() {
        this.asyncTemplateSave(this.currentApp)
      },
      showDetail(app) {
        this.currentApp = app
        this.showModal = true
      }
    },
    mixins: [ModelMapper],
    name: 'Index'
  }
</script>

<style scoped>

  * {
    color: black;
  }

</style>
